export const calculateTotals = (transactionList) => {
  const toNumber = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

  // Sales total (sum of each sale total)
  const grandTotalTransactionAmount = transactionList.reduce((sum, tx) => {
    const salesTotal = (tx.sales || []).reduce((tSum, sale) => tSum + toNumber(sale?.total), 0);
    return sum + salesTotal;
  }, 0);

  // Discounts
  const discountAmount = transactionList.reduce((sum, tx) => sum + toNumber(tx?.discount), 0);

  // Labour charges (if present)
  const labourCharges = transactionList.reduce((sum, tx) => sum + toNumber(tx?.labourCharges?.total || 0), 0);

  // Damage refunds (sum of each refund total)
  const damageRefund = transactionList.reduce((sum, tx) => {
    const dTotal = (tx.damageRefunds || []).reduce((tSum, d) => tSum + toNumber(d?.total), 0);
    return sum + dTotal;
  }, 0);

  // Payments received directly (paymentAmount)
  const grandTotalPaidAmount = transactionList.reduce((sum, tx) => sum + toNumber(tx?.paymentAmount), 0);

  // Tray payments (numberOfTrays * costPerTray) – exclude trays marked excludePayment
  const grandTrayPaymentAmount = transactionList.reduce((sum, tx) =>
    sum + (tx.trays || []).reduce((tSum, tray) => {
      if (tray?.excludePayment) return tSum;
      return tSum + (toNumber(tray?.numberOfTrays) * toNumber(tray?.costPerTray));
    }, 0)
  , 0);

  // Total paid (payment + tray payments)
  const totalPaid = grandTotalPaidAmount + grandTrayPaymentAmount;

  // Overall amount due (sales + labour) - (discount + damageRefund + totalPaid)
  const totalDueAmount = (grandTotalTransactionAmount + labourCharges) - (discountAmount + damageRefund + totalPaid);

  return {
    grandTotalTransactionAmount,
    discountAmount,
    labourCharges,
    damageRefund,
    grandTotalPaidAmount,
    grandTrayPaymentAmount,
    totalPaid,
    totalDueAmount,
  };
};

export default calculateTotals;
